
    import { Component, Vue } from 'nuxt-property-decorator';

    @Component
    export default class SliderNavBtns extends Vue {
        emit(eventName: string) {
            this.$emit(eventName);
        }
    }
